<div class="designs-page">

  <div class="page-header">
    <div class="page-title">
      <mat-icon class="page-icon">architecture</mat-icon>
      <h1>Designs</h1>
    </div>
    <button mat-raised-button color="primary" class="new-btn" (click)="newDesign()">
      <mat-icon>add</mat-icon>
      New Design
    </button>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
    <p>Loading designs…</p>
  </div>

  <!-- Error -->
  <div class="error-banner" *ngIf="error">{{ error }}</div>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="!loading && !error && designs.length === 0">
    <mat-icon class="empty-icon">architecture</mat-icon>
    <h2>No designs yet</h2>
    <p>Create your first floor plan, site map, or layout diagram.</p>
    <button mat-raised-button color="primary" (click)="newDesign()">
      <mat-icon>add</mat-icon> Create Design
    </button>
  </div>

  <!-- Design grid -->
  <div class="designs-grid" *ngIf="!loading && designs.length > 0">
    <div class="design-card" *ngFor="let d of designs" (click)="editDesign(d)">
      <div class="design-thumbnail">
        <img *ngIf="d.thumbnailData" [src]="d.thumbnailData" [alt]="d.name" />
        <div *ngIf="!d.thumbnailData" class="thumb-placeholder">
          <mat-icon>architecture</mat-icon>
        </div>
      </div>
      <div class="design-info">
        <div class="design-name">{{ d.name }}</div>
        <div class="design-desc" *ngIf="d.description">{{ d.description }}</div>
        <div class="design-date">Updated {{ formatDate(d.updatedAt) }}</div>
      </div>
      <div class="design-actions">
        <button mat-icon-button matTooltip="Edit" (click)="editDesign(d); $event.stopPropagation()">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Delete" class="delete-btn"
                (click)="deleteDesign(d, $event)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

</div>
